import { render, staticRenderFns } from "./FiLifePolicyList.vue?vue&type=template&id=6572247b"
import script from "./FiLifePolicyList.vue?vue&type=script&lang=js"
export * from "./FiLifePolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports